import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import classnames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { translationHookOptions } from "../app/localization/localization";
import { RootStoreContext } from "../app/stores/rootStore";
import InfoMessage from "../components/common/InfoMessage";
import Loader from "../components/common/Loader";
import TreeComponent from "../components/widgets/TreeComponent";

const OfflineBoardPage = () => {
  const rootStore = useContext(RootStoreContext);
  const { currentTenant, loadMainBoardFromDb, mainBoardTree } =
    rootStore.offlineStore;
  const { theme } = rootStore.commonStore;
  const [treeLoaded, setTreeLoaded] = useState(false);
  const [t] = useTranslation(
    ["nativeapp", "features"],
    translationHookOptions
  );
  const {isMobileMediaQuery} = rootStore.responsiveStore;

  useEffect(() => {
    loadMainBoardFromDb(currentTenant!.id)
      .then(() => {
        const scrollableElement = document.querySelector(".odgPage");
        if (scrollableElement) disableBodyScroll(scrollableElement);
      })
      .catch()
      .finally(() => setTreeLoaded(true));

    return () => {
      const scrollableElement = document.querySelector(".odgPage");
      if (scrollableElement) enableBodyScroll(scrollableElement);
    };
  }, [loadMainBoardFromDb, currentTenant]);

  if (!treeLoaded) return <Loader />;

  return (
    <>
      {mainBoardTree ? (
        <div className="odgPage">
          <Row>
            <div className={classnames(isMobileMediaQuery ? "odgTitoloMobile" :
            "odgTitolo"," text-white bg-dark")}>
              {t("board_page_title_bar", { ns : "features" })}
            </div>
          </Row>
          <Row>
            <Col xs={12} className="odgContainer">
              {mainBoardTree && (
                <TreeComponent
                  tenant={currentTenant!}
                  nodes={mainBoardTree.tree}
                  type="boards"
                  sourceId={mainBoardTree.boardId}
                />
              )}
            </Col>
          </Row>
        </div>
      ) : (
        <InfoMessage
          message={t("no_downloaded_board")}
          color={theme!.infoMessageColor}
          icon="fa fa-exclamation-circle fa-3x"
        />
      )}
    </>
  );
};

export default observer(OfflineBoardPage);
